import { render, staticRenderFns } from "./StudentElementaryGrades.vue?vue&type=template&id=1d8bf59e"
import script from "./StudentElementaryGrades.vue?vue&type=script&lang=js"
export * from "./StudentElementaryGrades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports